import { FC } from 'react';
import { Edit } from '@agendapro/emerald-icons';
import { BannerLogoProps } from './BannerLogo.types';
import * as St from './BannerLogo.styles';
import { EditProfileButton } from '../EditProfileButton';
import { editCompanyUrls } from '@/utils/canEditOwnCompany';

export const BannerLogo: FC<BannerLogoProps> = ({ banner, collapsed, canEdit, locationId }) => {
  const url = `${editCompanyUrls.locations}?action=edit_local_image&locationId=${locationId}`;

  return (
    <St.Wrapper collapsed={collapsed}>
      {canEdit && (
        <EditProfileButton
          url={url}
          className="absolute z-[1] top-4 right-4 w-[44px] h-[44px] bg-background-primary border border-solid border-border-brand rounded-full flex items-center justify-center cursor-pointer"
          mixpanelEvent="editLocationImage"
        >
          <Edit size={24} className="[&>path]:fill-icon-brand" />
        </EditProfileButton>
      )}
      {!collapsed && banner ? (
        <St.NextImage data-testid="banner" src={banner} layout="responsive" alt="company banner" />
      ) : (
        <St.BannerGradient />
      )}
    </St.Wrapper>
  );
};
